import * as fromDatatype from '../../../../models/datatype-library';

export class AppLoginSubjectExtension {
  guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export namespace AppLoginSubjectExtension {
  export enum ExtType {
    SYSTEM_DEFAULT = "SYSTEM_DEFAULT",
    APPLET_DEVELOPER = "APPLET_DEVELOPER"
  }

  export enum ExtCode {
    OPTIONAL_PARAM = "OPTIONAL_PARAM"
  }

  export enum ParamCode {
    FIRST_NAME = "FIRST_NAME",
    LAST_NAME = "LAST_NAME"
  }

}

